import React from "react"
// import PropTypes from "prop-types"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const RadioOption = ({
  field: { name, value, onChange, onBlur },
  form,
  id,
  error,
  label,
  ...props
}) => (
  <FormGroup check>
    <Label check>
      <Input
        {...props}
        type="radio"
        name={name}
        value={id}
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        invalid={Boolean(error)}
      />{" "}
      {label}
      {error && <FormFeedback valid={false}>{error}</FormFeedback>}
    </Label>
  </FormGroup>
)

export default RadioOption
